import { useEffect } from "react";

/**
 * Warn the user before closing/navigating away while an operation
 * (e.g. an upload) is in flight. Browser will show a generic dialog.
 */
export function useUnloadWarning(active: boolean, message = "Uploads are still in progress. Leave anyway?") {
  useEffect(() => {
    if (!active) return;
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      // Chrome requires returnValue to be set.
      e.returnValue = message;
      return message;
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [active, message]);
}
